import { render, staticRenderFns } from "./Import1.vue?vue&type=template&id=54388f1f&scoped=true&"
import script from "./Import1.vue?vue&type=script&lang=js&"
export * from "./Import1.vue?vue&type=script&lang=js&"
import style0 from "./Import1.vue?vue&type=style&index=0&id=54388f1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54388f1f",
  null
  
)

export default component.exports